module.exports = __webpack_public_path__ + "static/img/ICBC银行.64cbf1c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ICBC银行.jpg
// module id = V5L7
// module chunks = 1